// extracted by mini-css-extract-plugin
export default {"termsAndConditions":"TrailDetails_termsAndConditions__txCTI","bottomPadding":"TrailDetails_bottomPadding__rWl28","listStyling":"TrailDetails_listStyling__PbY8n"};